import { render } from "./NuevoProyecto.vue?vue&type=template&id=684c63d0"
import script from "./NuevoProyecto.vue?vue&type=script&lang=js"
export * from "./NuevoProyecto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__